<template>
  <!--
    Minimal customer-facing layout — no sidebar/topbar chrome. The
    /service/:token page renders its own full-bleed UI, so this layout
    is intentionally just a pass-through wrapper.
  -->
  <div class="service-layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SERVICE-LAYOUT',
};
</script>
